module.exports = __webpack_public_path__ + "img/niger.6ef02e94.svg";